import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Typography,
  Row,
  Col,
  Button,
  Icon,
  Upload,
  Input,
  message,
} from "antd";
import moment from "moment";
import { platformApi } from "../../../../../api";
import { formatValue } from "../../../../../utils";
import { ENDPOINT } from "../../../../../constants";

const { Text } = Typography;

const DownloadData = ({
  form,
  validityRef,
  clearRef,
  data,
  isSales,
  open,
  saveHere,
  editable,
  id,
  setBFlag,
}) => {
  const [generatedPDF, setGeneratedPDF] = useState(false);
  const [verifiedStatus, setVerifiedStatus] = useState(false);
  const [finance, setFinance] = useState({});
  const [digital, setDigital] = useState(false);
  const [verifiedTime, setVerifiedTime] = useState(null);
  const [manual, setManual] = useState(false);
  const [loading, setLoading] = useState(false);
  const [authStatus, setAuthStatus] = useState("Pending");
  const [refId, setRefId] = useState(0);

  useEffect(() => {
    const phone = data?.customer?.contacts?.[0]?.phone || data?.customerPhone || data?.customer?.phone;
    form.setFieldsValue({ registeredNumber: phone });
    setGeneratedPDF(data.authentication && data.authentication.beforeVerification);
    setVerifiedStatus((data.authentication && data.authentication.verifiedAt) || false);
    setVerifiedTime(
      data.authentication && data.authentication.verifiedAt
        ? !data.authentication.verifiedAt.includes("/")
          ? moment(data.authentication.verifiedAt).format("DD/MM/YYYY, h:mm:ss a")
          : data.authentication.verifiedAt
        : null
    );
    setDigital(data.authentication && data.authentication.digital);
    setAuthStatus(
      data.authentication && data.authentication.verifiedAt ? "Verified" : "Pending"
    );
    setManual(data.authentication && data.authentication.manual);

    if (!isSales) {
      downloadPdf(false);
    }
  }, [data]);

  useEffect(() => {
    if (!isSales && data?.loan?.financer?.id) {
      platformApi.get(`api/financer/${data.loan.financer.id}`).then((result) => {
        const { data: resData } = result;
        if (resData.code === 200) {
          const { response } = resData;
          if (response.code === 200) setFinance(response.data);
        }
      });
    }
  }, [open, data]);

  useEffect(() => {
    clearRef.current = () => {
      form.resetFields();
      setRefId(0);
    };
    validityRef.current = () => validatePage();
    // ← NO cleanup that nulls the refs
  });

  const validatePage = () => {
    let isValid = true;
    if (editable) {
      form.validateFields((validationError) => {
        isValid = validationError === null;
      });
    } else {
      isValid = true;
    }
    if (isValid) {
      data.authentication = {
        ...(data.authentication || {}),
        digital: digital,
        verifiedAt: verifiedTime,
      };
    }
    return isValid;
  };

  const handleChanger = (info) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      setBFlag(true);
    } else if (info.file.status === "done") {
      message.success("File Uploading ...");
      const formData = new FormData();
      formData.append("profile", info.file.originFileObj);
      formData.append("master", "Transaction Master");
      formData.append("module", "Booking");
      formData.append("id", id);
      platformApi
        .post("/api/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          setLoading(false);
          const { data } = res;
          if (data.code === 200) {
            const { Location } = data.response.data;
            message.success("File Uploaded");
            setBFlag(false);
            data.authentication = {
              ...data.authentication,
              afterVerification: Location,
              verifiedAt: moment(new Date()).format("DD/MM/YYYY, h:mm:ss a"),
            };
            setVerifiedStatus(true);
            setVerifiedTime(moment(new Date()).format("DD/MM/YYYY, h:mm:ss a"));
          } else {
            message.error("Upload Not Done");
          }
        })
        .catch((error) => {
          console.error("Error on Files Modal : ", error);
          setLoading(false);
        });
    }
  };

  const generateOtp = () => {
    const customerObj = data.customer || {};
    const phone = customerObj.contacts?.[0]?.phone || data.customerPhone || customerObj.phone;
    platformApi
      .post("/api/sendSms/sendOtp", {
        phone: phone,
        type: "WhatsApp",
        smsData: {
          link: data.authentication.beforeVerification,
          cname: customerObj.name || data.customerName,
          slex: data.executive,
          bkid: data.bookingId,
          vname: data.vehicle?.modelName,
          dlr: data.branch,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          const { data } = res.data.response;
          setRefId(data.referenceId);
          message.success("OTP will be sent to your mobile number");
        } else if (data.code === 400) {
          message.error(data.message);
        } else if (res.data.code === 401) {
          message.error(res.data.message);
        }
      });
  };

  const verifyOtp = () => {
    platformApi
      .post("/api/sendSms/verifyOtp", {
        referenceId: refId,
        passcode: form.getFieldValue("otp"),
      })
      .then((res) => {
        if (res.data.code === 200) {
          if (res.data.response.data.isValid) {
            message.success("OTP Verified");
            setDigital(true);
            setAuthStatus("Verified");
            data.authentication = {
              ...data.authentication,
              digital: true,
              verifiedAt: moment(new Date()).format("DD/MM/YYYY, h:mm:ss a"),
            };
            setVerifiedStatus(true);
            setVerifiedTime(moment(new Date()).format("DD/MM/YYYY, h:mm:ss a"));
            saveHere();
          } else if (res.data.code === 401) {
            message.error(res.data.message);
          } else {
            message.error("Wrong OTP Code");
            setDigital(false);
            setAuthStatus("Pending");
          }
        }
      });
  };

  const getLoanDate = (no) => {
    switch (no) {
      case 1: return "1st";
      case 2: return "2nd";
      case 3: return "3rd";
      default: return no + "th";
    }
  };

  const downloadPdf = (newOpenModal = true) => {
    if (data.loan) {
      if (editable || !manual) {
        const pdfUrl = `${ENDPOINT}api/pdfGenerate/booking/generatePDFByID/${data.id || id}`;
        if (newOpenModal) {
            message.success("PDF Report Opened");
            window.open(pdfUrl);
        }
        data.authentication = {
            ...data.authentication,
            beforeVerification: pdfUrl,
        };
        setGeneratedPDF(true);
      } else {
        window.open(data.authentication.afterVerification);
      }
    }
  };

  const { getFieldDecorator } = form;

  return (
    <Form style={{ marginTop: "4%", marginBottom: "4%" }}>
      <Text strong>Digital Authentication</Text>
      <Row type="flex" justify="space-between">
        <Col span={22}>
          <Form.Item colon={false} label={<Text>Registered Phone Number</Text>}>
            <Row type="flex" justify="space-between">
              <Col span={7}>
                {getFieldDecorator("registeredNumber")(
                  <Input
                    placeholder="Registered Phone Number"
                    onKeyUp={(e) =>
                      form.setFieldsValue({ registeredNumber: formatValue(e, "onlyNo") })
                    }
                    disabled
                  />
                )}
              </Col>
              <Col span={7}>
                <Button disabled={!editable || !generatedPDF} type="primary" onClick={generateOtp}>
                  Generate OTP and Link
                </Button>
              </Col>
              <Col span={7}>
                <Text strong>Authentication Status </Text>:
                {verifiedTime ? "Verfied" : "Pending"}
              </Col>
            </Row>
          </Form.Item>
        </Col>
      </Row>

      <Row type="flex" justify="space-between">
        <Col span={22}>
          <Form.Item colon={false} label={<Text>Enter OTP</Text>}>
            <Row type="flex" justify="space-between">
              <Col span={7}>
                {getFieldDecorator("otp")(
                  <Input
                    disabled={!editable}
                    onKeyUp={(e) => form.setFieldsValue({ pincode: formatValue(e, "onlyNo") })}
                    placeholder="Enter OTP"
                  />
                )}
              </Col>
              <Col span={7}>
                <Button disabled={!editable} type="primary" onClick={verifyOtp}>
                  Verify
                </Button>
              </Col>
              <Col span={7} />
            </Row>
          </Form.Item>
        </Col>
      </Row>

      <br />
      <Text strong>Manual Authentication</Text>
      <Row type="flex" justify="space-between">
        <Col span={11}>
          <Form.Item colon={false} label={<Text>Download Booking Form</Text>}>
            <Button onClick={downloadPdf}>
              Click to download &nbsp;&nbsp;
              <Icon type="download" />
            </Button>
          </Form.Item>
        </Col>
        <Col span={11}>
          <Form.Item colon={false} label={<Text>Upload Booking Form</Text>}>
            {getFieldDecorator("bookingFormUpload")(
              <Upload
                showUploadList={false}
                onChange={handleChanger}
                action={`${ENDPOINT}api/upload/mocky`}
                multiple={false}
                listType="text"
                accept=".pdf,.doc,.docx"
                disabled={!editable}
              >
                <Button
                  disabled={(!editable && manual) || authStatus === "Verified" || loading}
                >
                  Upload Booking Form&nbsp;&nbsp; <Icon type="upload" />
                </Button>
              </Upload>
            )}
          </Form.Item>
        </Col>
      </Row>

      {verifiedTime && (
        <Row justify="space-between" align="center" style={{ margin: "10px" }}>
          <Col span={11} marginTop="15px">
            <Text strong>Verified Time </Text>:{verifiedTime}
          </Col>
        </Row>
      )}
    </Form>
  );
};

const WrappedDownloadData = Form.create()(DownloadData);
export default WrappedDownloadData;